import 'jquery';
import 'moment';
import Chart from 'chart.js/auto';
window.Chart = Chart;
import 'bootstrap/dist/js/bootstrap.js';
import 'fullcalendar/dist/fullcalendar.js';
import 'fullcalendar/dist/fullcalendar.css';

import 'bootstrap/dist/css/bootstrap.css';
import 'angular-material/angular-material.css';
import 'angular-loading-bar/build/loading-bar.css';
import 'angularjs-toaster/toaster.css';
import '../styles/main.css';

import angular from 'angular';
import 'angular-animate';
import 'angular-sanitize';
import 'angular-ui-router';
import 'angular-material';
import 'angular-aria'; 
import 'angular-messages';
import 'angular-file-saver'; 
import 'angular-loading-bar';
import 'satellizer';
import 'angularjs-toaster';
import 'angular-ui-calendar';

import './sia-chatbot.js';
